import { useEffect, useState } from "react";
import { MdCheck, MdDelete, MdLink, MdPendingActions } from "react-icons/md";

const Accordion = ({
  integrationData,
  setIntegrationData,
  setAddEmailBox,
  handleDelete,
}) => {
  const [mails, setMails] = useState(null);

  useEffect(() => {
    if (integrationData) {
      setMails(integrationData.emails);
    }
  }, [integrationData]);

  return (
    <div className="bg-white rounded-lg w-full flex flex-col gap-2 mt-4 p-2">
      <div className="p-2">
        <header className="cursor-pointer px-2 py-3 border-bottom flex gap-x-3 items-center">
          <MdLink className="text-2xl text-gray-500" />
          <p className="text-xl font-semibold">Connecting Mailbox</p>
        </header>
        <div className="px-2 py-3">
          <div className="flow-root">
            <div className="overflow-x-auto">
              <div className="min-w-full border overflow-hidden rounded-xl">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900"
                      >
                        Email
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Name
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Verification
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {mails?.map((person) => (
                      <tr key={person.email}>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 flex gap-3 justify-start items-center">
                          <img
                            src={person.data.photos[0].url}
                            alt="user_photo"
                            className="w-12 h-12 rounded-full overflow-hidden"
                          />
                          <p>{person.data.emailAddresses[0].value}</p>
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          {person.data.names[0].displayName}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          {person.data.emailAddresses[0].metadata?.verified ? (
                            <div className="p-1 bg-green-200 w-fit rounded-full">
                              <MdCheck className="text-green-500 text-2xl" />
                            </div>
                          ) : (
                            <div className="p-1 bg-red-200 w-fit rounded-full shadow">
                              <MdPendingActions className="text-red-500 text-2xl" />
                            </div>
                          )}
                        </td>
                        <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-xl font-medium">
                          <MdDelete
                            className="cursor-pointer text-gray-400 hover:text-red-400"
                            onClick={() => {
                              handleDelete(person.email);
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <button
                className="text-white mt-3 bg-indigo-600 py-1.5 rounded-md px-3.5 hover:bg-indigo-500 hover:cursor-pointer"
                onClick={() => {
                  setAddEmailBox(true);
                }}
              >
                Connect your mailbox
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Accordion;
